/** Public Creator Program marketing site */
export const CREATOR_PROGRAM_PATH = '/creator-program';
export const CREATOR_APPLY_PATH = '/creator-program/apply';

/** Authenticated creator studio + onboarding */
export const CREATOR_STUDIO_BASE = '/creator';
export const CREATOR_ONBOARDING_PATH = '/creator/onboarding';

export const CREATOR_PATHS = {
  dashboard: '/creator/dashboard',
  links: '/creator/links',
  storefront: '/creator/storefront',
  products: '/creator/products',
  collections: '/creator/collections',
  campaigns: '/creator/campaigns',
  analytics: '/creator/analytics',
  earnings: '/creator/earnings',
  orders: '/creator/orders',
  walletGuide: '/creator/wallet-guide',
  settings: '/creator/settings',
  achievements: '/creator/achievements',
  leaderboard: '/creator/leaderboard',
  assets: '/creator/assets',
  notifications: '/creator/notifications',
} as const;

export type CreatorStudioPath = (typeof CREATOR_PATHS)[keyof typeof CREATOR_PATHS];

export function isCreatorStudioPath(pathname: string): boolean {
  return (
    pathname === CREATOR_STUDIO_BASE ||
    pathname.startsWith(`${CREATOR_STUDIO_BASE}/`)
  );
}

/** Creator studio entry: onboarding until setup is complete. */
export function resolveCreatorStudioPath(onboardingComplete?: boolean | null): string {
  if (onboardingComplete === false) return CREATOR_ONBOARDING_PATH;
  return CREATOR_PATHS.dashboard;
}

export function isCreatorProgramFlowPath(pathname: string): boolean {
  return (
    pathname === CREATOR_PROGRAM_PATH ||
    pathname.startsWith(`${CREATOR_PROGRAM_PATH}/`) ||
    pathname === CREATOR_APPLY_PATH ||
    pathname.startsWith(`${CREATOR_APPLY_PATH}/`)
  );
}
